var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import Box from "../box/Box";
import { makePseudoButtonProps } from "onnit-ui/lib/utils/PropUtils";
export function MediaListGrid(_a) {
    var _b = _a.gridTemplateColumns, gridTemplateColumns = _b === void 0 ? "1fr 1fr" : _b, rest = __rest(_a, ["gridTemplateColumns"]);
    return (React.createElement(Box, __assign({ display: ["block", "block", "grid"], gridTemplateColumns: ["1fr", "1fr", gridTemplateColumns], maxWidth: 1260, mx: "auto" }, rest)));
}
function MediaListItem(_a) {
    var image = _a.image, headline = _a.headline, description = _a.description, url = _a.url, rest = __rest(_a, ["image", "headline", "description", "url"]);
    var buttonProps = url
        ? makePseudoButtonProps(function () {
            if (url) {
                window.location.href = url;
            }
        })
        : {};
    return (React.createElement(Box, __assign({}, rest, buttonProps, { display: "flex", alignItems: "center" }),
        React.createElement(Box, { flex: "0 0 25%", ml: [5, 5, 5, 7] }, image),
        React.createElement(Box, { flex: "1 1 auto", display: ["block", "block", "flex"], alignItems: "center", flexDirection: description ? ["column", "column", "row"] : "row" },
            React.createElement(Box, { flex: description ? "0 0 40%" : "1 1 auto", px: 4, py: 2 }, headline),
            description && (React.createElement(Box, { flex: "1 1 60%", p: [1, 2] }, description)))));
}
export default MediaListItem;
//# sourceMappingURL=MediaListItem.js.map